import React from "react";
const ADVISOR_IMAGE = "https://cdn.magicpatterns.com/patterns/generated-images/001ac93b-9646-4cb4-ab12-80e25fd8c8f4.jpg";
export function Intro() {
  return <section id="cabinet" className="w-full bg-white py-24 lg:py-32" data-id="element-103" data-mp="27ikwio29i2o9">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-104" data-mp="2lfhowty13s79">
        <div className="lg:col-span-7" data-id="element-105" data-mp="2ghg526ss3ouq">
          <h2 className="text-sm font-semibold text-brand" data-id="element-106" data-mp="1src2m2rbtv5b">Le cabinet</h2>
          <blockquote className="mt-6 font-serif text-3xl leading-snug text-ink sm:text-4xl lg:text-[44px] lg:leading-[1.2]" data-id="element-107" data-mp="1srlw40bkykfr">
            « Nos spécialistes vous guident vers les investissements les plus avantageux et vous accompagnent à
            chaque étape. »
          </blockquote>
          <div className="mt-10 grid gap-8 border-t border-line pt-10 sm:grid-cols-2" data-id="element-108" data-mp="1xou9zopp42b7">
            <p className="leading-relaxed text-muted" data-id="element-109" data-mp="19zjh0tel7c7m">
              Quelle que soit votre ambition, nos experts vous guident vers les investissements les plus
              pertinents et vous proposent une solution sur mesure et un suivi complet.
            </p>
            <p className="leading-relaxed text-muted" data-id="element-110" data-mp="6owvzcpthlbw">
              Chez Success Capital, nous concevons des solutions entièrement personnalisées pour répondre à vos
              besoins spécifiques, avec une prise en charge complète.
            </p>
          </div>
        </div>
        <figure className="lg:col-span-5" data-id="element-111" data-mp="3ewvj79sz0o1b">
          <img src={ADVISOR_IMAGE} alt="Une conseillère Success Capital étudie un dossier client" className="aspect-[4/5] w-full rounded-2xl object-cover" data-id="element-112" data-mp="3ey6x42g4rc65" />
          <figcaption className="mt-4 text-sm text-muted" data-id="element-113" data-mp="3nwsdbqy4qf3r">Un conseiller dédié, du premier rendez-vous au suivi.</figcaption>
        </figure>
      </div>
    </section>;
}